import React from 'react';
import classes from './GalleryItem.module.css';
import { categoryImages, formatPostItemDateRange, formatSimpleDate, getRgbFromColorName, truncateText, utcToLocalDateTime } from 'shared/utility';

const galleryItem = (props) => {
  let categoryImage = null;
  categoryImage = categoryImages.find((category) => category.name === props.photo.postDetails.Type);
  const startDate = formatPostItemDateRange(props.photo.postDetails.DateStartCalc, props.photo.postDetails.DateEndCalc);
  const dateModified =
    props.photo.postDetails && props.photo.postDetails.DatePostUpdated
      ? formatSimpleDate(utcToLocalDateTime(props.photo.postDetails.DatePostUpdated).toString())
      : '';
  const dateAdded =
    props.photo.postDetails && props.photo.postDetails.DateCreated
      ? formatSimpleDate(utcToLocalDateTime(props.photo.postDetails.DateCreated).toString())
      : '';
  const footerDate =
    props.photo.sortBy === 'DateStart' ? null : (
      <p className={classes.Date}>{props.photo.sortBy === 'DatePostUpdated' ? `Modified: ${dateModified}` : `Added: ${dateAdded}`}</p>
    );
  return (
    <div
      key={`${props.keyId}-${props.index}`}
      id={props.keyId}
      onClick={() => props.clicked(props.photo.postDetails.PostId, 'gallery')}
      style={{
        margin: props.margin,
        height: props.photo.height ? props.photo.height : 0,
        width: props.photo.width ? props.photo.width : 0,
        backgroundColor: '#eee',
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative',
      }}
      className="imageContainer"
    >
      <div className="imageContainer">
        <img
          alt={props.photo.title}
          src={props.photo.src}
          style={{
            height: props.photo.height ? props.photo.height : 0,
            width: props.photo.width ? props.photo.width : 0,
          }}
        />
      </div>

      {props.photo.imageSize === 'large' && props.photo.width >= 110 ? (
        <div
          className={['overlay', classes.GalleryImageOverlay].join(' ')}
          style={{ maxHeight: props.photo.height - 16, width: props.photo.width - 16 }}
        >
          <div className={classes.OverlayInnerContainer}>
            {categoryImage ? (
              <div className={classes.ContentType}>
                <categoryImage.image />
              </div>
            ) : null}
            <h1>{truncateText(props.photo.postDetails.Name, 110)}</h1>
            <p className={classes.Date}>{startDate}</p>
            {footerDate}
            <p
              style={{
                color: props.photo.postDetails.Color ? getRgbFromColorName(props.photo.postDetails.Color) : 'rgb(108, 162, 183)',
              }}
              className={classes.Author}
            >
              {props.photo.postDetails.FirstName}
            </p>
          </div>
        </div>
      ) : null}

      <style>
        {`.imageContainer:hover .overlay{display: block !important}
.imageContainer:hover .imageContainer{background-color: #202a2f}
.imageContainer:hover .imageContainer img{opacity: .3}`}
      </style>
    </div>
  );
};

export default galleryItem;
